<template>
  <div class="collapsible-notes-field">
    <button
      type="button"
      class="collapsible-notes-toggle"
      :aria-expanded="expanded ? 'true' : 'false'"
      @click="expanded = !expanded"
    >
      <AppIcon :name="expanded ? 'bi-chevron-down' : 'bi-chevron-right'" class="collapsible-notes-chevron" />
      <span>{{ label || $t('add_note') }}</span>
      <span class="collapsible-notes-optional">({{ $t('optional') }})</span>
    </button>
    <div v-if="expanded" class="collapsible-notes-panel">
      <textarea
        v-bind="$attrs"
        :value="value"
        :rows="rows"
        class="form-control"
        :placeholder="placeholder || $t('add_notes')"
        @input="$emit('input', $event.target.value)"
      ></textarea>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleNotesField',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      expanded: false
    }
  }
}
</script>

<style scoped>
.collapsible-notes-field {
  padding-top: 0.75rem;
}

.collapsible-notes-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #344054;
  display: flex;
  font-size: 0.95rem;
  font-weight: 600;
  gap: 0.65rem;
  padding: 0.35rem 0;
  text-align: start;
  width: 100%;
}

.collapsible-notes-toggle:hover {
  color: var(--bs-primary);
}

.collapsible-notes-toggle:focus-visible {
  border-radius: 0.25rem;
  outline: 2px solid var(--bs-primary);
  outline-offset: 2px;
}

.collapsible-notes-chevron {
  flex: 0 0 auto;
  font-size: 1rem;
}

.collapsible-notes-optional {
  color: #98a2b3;
  font-weight: 400;
}

.collapsible-notes-panel {
  padding-top: 0.75rem;
}
</style>
